var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9577H7.50033C2.97533 18.9577 1.04199 17.0243 1.04199 12.4993V7.49935C1.04199 2.97435 2.97533 1.04102 7.50033 1.04102H12.5003C17.0253 1.04102 18.9587 2.97435 18.9587 7.49935V12.4993C18.9587 17.0243 17.0253 18.9577 12.5003 18.9577ZM7.50033 2.29102C3.65866 2.29102 2.29199 3.65768 2.29199 7.49935V12.4993C2.29199 16.341 3.65866 17.7077 7.50033 17.7077H12.5003C16.342 17.7077 17.7087 16.341 17.7087 12.4993V7.49935C17.7087 3.65768 16.342 2.29102 12.5003 2.29102H7.50033Z",
    fill: "#009D8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17128 12.365C9.04461 12.365 8.91794 12.3183 8.81794 12.2183L6.74461 10.145C6.55128 9.95167 6.55128 9.63167 6.74461 9.43833C6.93794 9.245 7.25794 9.245 7.45128 9.43833L9.17128 11.1583L12.6846 7.645C12.8779 7.45167 13.1979 7.45167 13.3913 7.645C13.5846 7.83833 13.5846 8.15833 13.3913 8.35167L9.52461 12.2183C9.42461 12.3183 9.29794 12.365 9.17128 12.365Z",
    fill: "#009D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.5b564f619845649417e69280398a7b92.svg";
export { ForwardRef as ReactComponent };